module.exports = __webpack_public_path__ + "media/images/classpoints/classpoints-hero_rumble-f6d7bd8c19b32540d581586b24d716b0.png";